export default "__VITE_ASSET__DXweEJOx__"